"use client";
import { jsx as p } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { DefaultState as s } from "./DefaultState.mjs";
import { LoadingState as u } from "./LoadingState.mjs";
import { SuccessState as n } from "./SuccessState.mjs";
import { FileInput as c } from "../../atoms/FileInput/FileInput.mjs";
const e = i(
  ({ children: r, state: t = "default", useButtonWrapper: o = !0, ...a }, m) => /* @__PURE__ */ p(
    c,
    {
      ref: m,
      state: t,
      useButtonWrapper: o && t !== "success",
      ...a,
      accept: "image/*",
      children: r
    }
  )
);
e.displayName = "ImageFileInput";
const S = Object.assign(e, {
  DefaultState: s,
  LoadingState: u,
  SuccessState: n
});
export {
  S as ImageFileInput
};
